import { useContext } from 'react'
import { Grid, Typography } from '@mui/material'

import { ErrorPage } from '../../../components/error-boundary/fallback'
import SearchResultsContext from '../context'
import useStyles from '../index.styles'

import ResultItem, { SkeletonResultItem } from './result-item'

// TODO: Needs design
const NoResults = () => <Typography variant="body1">There are no results</Typography>

const Results = ({ type }: { type: SearchTabsType }) => {
  const classes = useStyles
  const { isLoading, error, searchResults } = useContext(SearchResultsContext)

  const getValues = (item: ISearchResultAccount | ISearchResultPerson | ISearchResultDevice | ISearchResultOrder) => {
    let identifierText
    let title = ''
    let address
    let email
    let phone
    let folders
    let itemType
    let isDeactivated = false
    let folderId
    switch (type) {
      case 'accounts':
        title = (item as ISearchResultAccount)?.name
        identifierText = (item as ISearchResultAccount).accountNumber ? `Acct #${(item as ISearchResultAccount).accountNumber}` : ''
        address = (item as ISearchResultAccount).address
        itemType = (item as ISearchResultAccount).folderType
        isDeactivated = (item as ISearchResultAccount).isDeactivated
        break
      case 'devices':
        title = (item as ISearchResultDevice).vanity
        identifierText = `NodeID ${item.id}`
        address = (item as ISearchResultDevice).address
        isDeactivated = (item as ISearchResultDevice).isDeactivated
        break
      case 'people':
        title = (item as ISearchResultPerson)?.name
        email = (item as ISearchResultPerson).email
        phone = (item as ISearchResultPerson).phoneNumber
        folders = String((item as ISearchResultPerson).folderIds.length)
        itemType = (item as ISearchResultPerson).roleName
        break
      case 'orders':
        title = `${(item as ISearchResultOrder).orderType} #${(item as ISearchResultOrder).shortOrderNumber}`
        address = (item as ISearchResultOrder).address
        itemType = (item as ISearchResultOrder).status
        folderId = (item as ISearchResultOrder).folderId
        break
      default:
    }
    return { title, identifierText, address, email, phone, folders, itemType, isDeactivated, folderId }
  }

  return (
    <Grid
      container={true}
      sx={[
        { flexDirection: 'column' },
        {
          gap: '6px',
        },
        classes.resultItemContainer,
      ]}
    >
      {searchResults?.map((item, idx) => (
        <ResultItem
          key={idx}
          parentText={item.parents}
          title={getValues(item).title}
          identifierText={getValues(item).identifierText}
          address={getValues(item).address}
          email={getValues(item).email}
          phone={getValues(item).phone}
          folders={getValues(item).folders}
          itemType={getValues(item).itemType}
          isDeactivated={getValues(item).isDeactivated}
          linkTo={`/tenant/${item.tenantId}/${type}/${item.id}`}
        />
      ))}
      {searchResults && searchResults.length === 0 && !isLoading && <NoResults />}
      {error && <ErrorPage />}
      {isLoading && (
        <>
          <SkeletonResultItem />
          <SkeletonResultItem />
          <SkeletonResultItem />
        </>
      )}
    </Grid>
  )
}

export default Results
